import { IStatuses, IUserGraphRow } from '@dto/user/userInfo.dto'
import moment from 'moment/moment'
import { statusMapper } from '@utils/mappers'
import {BaseDefaultStatusesColumn, statusesList, statusesListD} from '@enums/base'
import { ICrmStatGraph } from '@dto/crm/crmInfo.dto'

export const statusGraphMapper = (value: IUserGraphRow[]) => {
  const result = []
  value
    .sort((a, b) => (moment(a.createdAt).isBefore(moment(b.createdAt)) ? -1 : 1))
    .forEach((el) => {
      statusesList.forEach((e) =>
        result.push({
          category: statusMapper(e as BaseDefaultStatusesColumn),
          value: el[e],
          day: moment(el.createdAt).format('YYYY-MM-DD'),
        }),
      )
    })
  return result
}

export const statusCrmGraphMapper = (value: ICrmStatGraph[]) => {
  const result = []
  value
    .sort((a, b) => (moment(a.date).isBefore(moment(b.date)) ? -1 : 1))
    .forEach((el) => {
        statusesListD.forEach((e) =>
        result.push({
          category: statusMapper(e as BaseDefaultStatusesColumn),
          value: el[e],
          day: moment(el.date).format('YYYY-MM-DD'),
        }),
      )
    })
  return result
}
